import { render, staticRenderFns } from "./ManageDeviceProductsList.vue?vue&type=template&id=1889a6a6"
import script from "./ManageDeviceProductsList.vue?vue&type=script&lang=js"
export * from "./ManageDeviceProductsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports